import React from 'react'
import HalfImageTextPanel from './HalfImageTextPanel'

const ImageTextPanel = ({items, handleProperties, cename,id ,handleCeAssets}) => {
    return <HalfImageTextPanel id={id} items={items} hideTitle={true} handleProperties={handleProperties} cename={cename} handleCeAssets={handleCeAssets}/>
}

export default ImageTextPanel
